<template>
	<!-- 选品上架 -->
	<div class="leoshop leopages">
		<LeoHandB title="选品上架" curactive="xpsj">
			<div slot="content">
				<van-sticky :offset-top="44">
					<div class="gd-top" :style="'background-color:' + gcfg.BackgroundColor">
						<div class="searchbox">
							<div class="searchbox-item">
								<div class="lefticon">
									<van-icon name="search" />
								</div>
								<div class="righttitle" @click="goSearchPage">
									<span>点击搜索</span>
								</div>
							</div>
						</div>
					</div>
				</van-sticky>
				<div class="leoshop-content">
					<van-swipe class="swipebox" :autoplay="3000" lazy-render v-if="images.length > 0">
						<van-swipe-item v-for="(item, index) in images" :key="index">
							<a :href="item.url">
								<van-image :src="item.image" :alt="item.title" />
							</a>
						</van-swipe-item>
					</van-swipe>
					<div class="grid-box grid-box5">
						<div class="grid-item grid-item5 bgcolor" v-for="(item, index) in recommendData" :key="index"
							@click="goPageList(index)">
							<van-icon v-if="item.name.indexOf('门票') != -1" class="van-icon iconfont" name="ziyuan3"
								class-prefix="icon" />
							<van-icon v-else-if="item.name.indexOf('酒店') != -1" class="van-icon iconfont" name="jiudian"
								class-prefix="icon" />
							<van-icon v-else-if="item.name.indexOf('度假') != -1" class="van-icon iconfont" name="lvyou1"
								class-prefix="icon" />
							<van-icon v-else-if="item.name.indexOf('美食') != -1" class="van-icon iconfont" name="meishika"
								class-prefix="icon" />
							<van-icon v-else-if="item.name.indexOf('包车') != -1" class="van-icon iconfont" name="yongche"
								class-prefix="icon" />
							<van-icon v-else-if="item.name.indexOf('拍') != -1" class="van-icon iconfont" name="xiangji"
								class-prefix="icon" />
							<van-icon v-else-if="item.name.indexOf('直通车') != -1" class="van-icon iconfont" name="zhitongche"
								class-prefix="icon" />
							<van-icon v-else-if="item.name.indexOf('特产') != -1" class="van-icon iconfont" name="tutechan"
								class-prefix="icon" />
							<van-icon v-else-if="item.name.indexOf('晚会') != -1" class="van-icon iconfont" name="wutai"
								class-prefix="icon" />
							<van-icon v-else-if="item.name.indexOf('巴士') != -1" class="van-icon iconfont" name="bus"
								class-prefix="icon" />
							<van-icon v-else class="van-icon iconfont" name="weibiaoti1" class-prefix="icon" />
							<p class="name">{{ item.name }}</p>
						</div>
					</div>

					<div class="listdata">
						<div class="listdata-title" :style="'background-color:' + gcfg.BackgroundColor">
							<span :style="'color:' + gcfg.TopTextColor">{{ switchName }}</span>
						</div>
						<div class="tabs">
							<div class="list" :class="item.isactive ? 'active' : ''" v-for="item in tabs" :key="item.value"
								@click="tabsclick(item)">{{ item.label }}</div>
						</div>
						<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad"
							:immediate-check="false">
							<van-cell v-for="(item, index) in productList" :key="index">
								<div class="cell-item" @click="goGoodsDetail(item.goods_id)">
									<div class="leftimg">
										<van-image :src="item.images" fit="cover"></van-image>
										<!-- <img > -->
									</div>
									<div class="right-content">
										<div class="title ells">
											{{ item.goods_name }}
										</div>
										<div class="remark" style="overflow: hidden;">
											<p class="ells" v-for="desc in item.describe.split('<br/>')">
												{{ desc }}
											</p>
										</div>
										<div class="price">
											<div class="xse">
												已售：<span>{{ item.sales_volume }}</span>份
											</div>
											<div class="yj">
												<span class="">{{ item.goods_price }}</span>
												<span> {{ item.status != '10' ? '未上架' : '已上架' }}</span>
											</div>
											<div class="xj">
												<span class="an">
													<van-icon name="plus" />
												</span>
											</div>
										</div>
									</div>

								</div>
							</van-cell>
						</van-list>

					</div>
				</div>

			</div>
		</LeoHandB>
	</div>
</template>

<script>
import LeoHandB from '../TP/LeoHandB.vue'
import * as util from '@/utils/network'
import {
	Toast
} from 'vant';
export default {
	components: {
		LeoHandB
	},
	data() {
		return {
			productList: [],
			loading: false,
			finished: false,
			activeName: '',
			images: [],
			isSc: false,
			re_value: '',
			gcfg: [],
			store: null,
			isNoData: false,
			pageIndex: 1,
			pageTotal: 0,
			storeid: this.$route.query.store_id,
			recommendData: [],
			tabs: [{
				label: '全部',
				value: '',
				isactive: true
			}, {
				label: '已上架',
				value: '10',
				isactive: false
			}, {
				label: '未上架',
				value: '20',
				isactive: false
			}],
			switchName: '分享推荐'
		}
	},
	methods: {
		goPageList(v) {
			this.$router.push({
				path: '/searchPageSjN',
				query: {
					active: v
				}
			})
		},
		async getSidebarData() {
			var url = "/addons/litestore/api.category/Showlist"
			let that = this;
			let id = that.storeId ? that.storeId : this.$store.getters.getShop
			//这里直接调用网络接口
			await util.get(url, {
				store_id: id
			},
				function (result) {
					that.recommendData = result['data']['categorydata']
				},
			);
		},
		goGoodsDetail(v) {
			this.$router.push({
				path: 'goodsdetail',
				query: {
					isSj: 'true',
					id: v
				}
			})
		},
		// 去查询界面
		goSearchPage() {
			this.$router.push({
				path: '/searchPageSjN'
			})
		},
		// 去店铺信息详情页面
		goShopNamePage() {
			this.$router.push({
				path: 'shopxq'
			})
		},
		// 收藏按钮功能
		handelSc() {
			let that = this;
			let msg = "收藏成功";
			that.isSc = !that.isSc;
			if (!that.isSc) {
				msg = '取消收藏';
			}
			Toast({
				message: msg
			});
		},
		onLoad() {
			// 异步更新数据
			let that = this
			// 异步更新数据
			that.pageIndex++;
			setTimeout(() => {
				that.getData();
			}, 1000)
		},
		async getBannerData() {
			let that = this;
			var url = "/addons/litestore/api.store/getSelectionBanner"
			let id = that.storeid ? that.storeid : this.$store.getters.getShop
			//这里直接调用网络接口
			await util.post(url, {
				page: that.pageIndex,
				store_id: id
			},
				function (result) {
					that.images = result.data
				},
			);
		},
		// 获取列表数据
		async getData() {
			let that = this;
			//util.isToken
			var url = "/addons/litestore/api.store/productList"
			let id = that.storeid ? that.storeid : this.$store.getters.getShop;
			let status = that.tabs.find(item => item.isactive).value;
			//这里直接调用网络接口
			let params = {
				page: that.pageIndex,
				store_id: id,
				status
			}
			if (this.$route.query.isNewShop) {
				params.is_new = 1
			}
			await util.post(url, params,
				function (result) {
					let data = result.data
					that.loading = false;
					//这里对状态 进行分类
					that.pageTotal = data.total
					if (that.pageTotal < 1) {
						that.isNoData = true
						return;
					}
					if (data.list == null || data.list.length === 0) {
						// 加载结束
						that.finished = true;
						return;
					}
					// 将新数据与老数据进行合并
					that.productList = that.productList.concat(data.list);

					//如果列表数据条数>=总条数，不再触发滚动加载
					if (that.productList.length >= that.pageTotal) {
						that.finished = true;
					}
				},
			);
		},
		// 点击tabs
		tabsclick(row) {
			this.tabs.forEach(item => {
				item.isactive = false;
				if (item.value == row.value) {
					item.isactive = true;
				}
			})
			this.pageIndex = 1;
			this.productList = [];
			this.isNoData = false;
			this.finished = false;
			this.getData();
		}
	},
	created() {
		if (this.$route.query.isNewShop) {
			this.switchName = '新品推荐';
		}
		this.gcfg = this.$store.getters.getGcfg
		// this.store = this.$store.getters.getShop
		this.getSidebarData();
		this.getData();
		this.getBannerData();
	},
	watch: {
		"$store.state.gcfg"() {
			this.gcfg = this.$store.getters.getGcfg
		},
		// "$store.state.shop"() {
		// 	this.store = this.$store.getters.getShop
		// }
	},
}
</script>
<style lang="less" scoped="scoped">
@import url("../../assets/css/base.less");
@import url("../../assets/css/listboxless.less");

.leftimg {
	width: 100px;

	img {
		width: 100%;
	}
}

.grid-box {
	display: flex;
	justify-content: space-between;
	flex-wrap: wrap;
	margin-top: 10px;
	margin: 10px;

	.grid-item {
		display: flex;
		flex-direction: column;
		align-items: center;
		box-sizing: border-box;
	}

	.grid-item2 {
		min-width: 0;
		flex-basis: 48.5%;

		.img {
			height: 110px;
		}
	}

	.grid-item3 {
		min-width: 0;
		flex-basis: 32.5%;

		.img {
			height: 138px;
		}
	}

	.grid-item5 {
		min-width: 0;
		flex-basis: 19.5%;

		.van-icon {
			font-size: 32px;
			padding-top: 10px;
		}

		.name {
			padding-bottom: 10px;
		}
	}

	.grid-item5:first-child {
		border-top-left-radius: 15px;
	}

	.grid-item5:last-child {
		border-bottom-right-radius: 15px;
	}

	.grid-item5:nth-child(5) {
		border-top-right-radius: 15px;
	}

	.grid-item5:nth-child(6) {
		border-bottom-left-radius: 15px;
	}

	.bgcolor {
		color: #fff;

		.name {
			margin-top: 5px;
			font-size: 14px;
			text-align: center
		}
	}

	.bgcolor:nth-child(n+6) {
		color: #000;
	}

	.bgcolor:first-child {
		background: linear-gradient(#f95f55, #fa8051);
	}

	.bgcolor:nth-child(2) {
		background: linear-gradient(#3e87fa, #4daafa);
	}

	.bgcolor:nth-child(3) {
		background: linear-gradient(#6084ff, #649eff);
	}

	.bgcolor:nth-child(4) {
		background: linear-gradient(#20bcaf, #1accbe);
	}

	.bgcolor:nth-child(5) {
		background: linear-gradient(#ff8a3a, #fea444);
	}

	.bgcolor:nth-child(6) {
		background-color: #fef4f2;

		.van-icon {
			color: #fd754d;
		}
	}

	.bgcolor:nth-child(7) {
		background-color: #eff8ff;

		.van-icon {
			color: #4599fc;
		}
	}

	.bgcolor:nth-child(8) {
		background-color: #f1f3ff;

		.van-icon {
			color: #7e84fe;
		}
	}

	.bgcolor:nth-child(9) {
		background-color: #ecfbf8;

		.van-icon {
			color: #50d2b6;
		}
	}

	.bgcolor:nth-child(10) {
		background-color: #fff9f1;

		.van-icon {
			color: #fd802c;
		}
	}
}

.grid-box5 {
	justify-content: space-around;
}

.grid-box5 {
	.grid-item5+.grid-item5 {
		// margin-left: 5px;
	}
}

.tabs {
	margin: 15px 0;
	display: flex;
	align-items: center;
	justify-content: flex-start;

	.list {
		font-size: 14px;
		margin: 0 30px;
		padding-bottom: 5px;
	}

	.list.active {
		font-weight: bold;
		color: #4599fc;
		border-bottom: 2px solid #4599fc;
	}
}
</style>
